import { gql } from '@apollo/client';

const hotel = gql`
  fragment CompleteHotel on Hotel {
    price
    margin
    priceWithMargin
    deprecatedTrainMargin
    passenger {
      firstName
      lastName
    }
    currency
    checkInDate
    validityEndDate
    jacTravelRef
    hotelId
    cancelled
    provisional
    itemRef
    itemId
    isDotwBooking
    eurostarReference
    bookerSurname
    canBeCancelledOnThirdParty
    hotelName
    numberOfNights
    guestCount
    roomCount
    hotelAddress
  }
`;

export default hotel;
